import {
  Component,
  ViewChild,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Chart, ChartData } from 'chart.js';
import { ChartModel } from '../../models';

@Component({
  selector: 'app-doughnut-chart',
  templateUrl: './doughnut-chart.component.html',
  styleUrls: ['./doughnut-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DoughnutChartComponent implements OnInit, OnDestroy {
  @ViewChild('doughnutChart', { static: true }) private chartRef;

  @Input() set data(data: ChartModel[]) {
    this.chartData = data;
    this.isData = (data || []).reduce((acc, cur) => acc + cur.value, 0) > 0;
    if (this.chart) {
      this.chart.data = this.setChartData();
      this.chart.config.options.tooltips.enabled = this.isData;
      this.chart.config.options.hover.mode = this.isData ? 'point' : null;
      this.chart.update();
    }
  }

  chart: Chart;
  chartData: ChartModel[];
  isData: boolean;

  get data() {
    return this.chartData;
  }

  setChartData(): ChartData {
    if (this.isData) {
      const chartData = this.data.filter((data) => data.showInChart);
      return {
        labels: chartData.map((data) => data.label),
        datasets: [
          {
            backgroundColor: chartData.map((data) => data.color),
            data: chartData.map((data) => data.value),
          },
        ],
      };
    }
    return {
      labels: [],
      datasets: [{ backgroundColor: 'rgba(238, 238, 238, 1)', data: [1] }],
    };
  }

  ngOnInit() {
    this.chart = new Chart(this.chartRef.nativeElement, {
      type: 'doughnut',
      data: this.setChartData(),
      options: {
        hover: { mode: this.isData ? 'point' : null },
        tooltips: { enabled: this.isData },
      },
    });
  }

  ngOnDestroy(): void {
    this.chart.destroy();
  }
}
